import comp from '../components/barrel';
import svg from '../js/svg';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-advisor-groups';
const COL_COUNT = 9;
const GROUP_TYPES = [
  {group_type: 'User', label: 'User'},
  {group_type: 'System', label: 'System'},
];

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

function ynText(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  return '—';
}

function createdByName(row) {
  return `${cellText(row.f_name)} ${cellText(row.s_name)}`.trim() || '—';
}

async function dateTimeText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDateTime(val);
}

function normaliseGroupType(value) {
  return value === 'System' ? 'System' : 'User';
}

export default {
  async prepare() {
    const listRestore = this.vars && this.vars.listRestore;
    this.vars.group_type = normaliseGroupType(listRestore && listRestore.group_type);
    this.recipe.methods.push(await O.mPOST(EP, {group_type: this.vars.group_type}));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const res = data[EP] || {};
    const rows = Array.isArray(res.data) ? res.data : [];
    await this.buildTableHead();
    await this.buildTableBody(rows);
    if (this.vars && this.vars.listRestore) {
      delete this.vars.listRestore;
    }
  },

  async buildTableHead() {
    const tableHead = U.id('advisorGroupsTableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    headRow.insertCell(0);

    const nameHead = headRow.insertCell(1);
    nameHead.innerHTML = 'Group name';

    const descHead = headRow.insertCell(2);
    descHead.innerHTML = 'Description';

    const advisorsHead = headRow.insertCell(3);
    advisorsHead.innerHTML = 'Advisors';

    const typeHead = headRow.insertCell(4);
    const typeDD = await comp.selectThead(
      'advisorGroupTypeDD',
      GROUP_TYPES,
      'group_type',
      'label',
      'thsPage.onGroupTypeChange()',
      ''
    );
    const selectEl = typeDD.querySelector('#advisorGroupTypeDD');
    if (selectEl) {
      const blankOpt = selectEl.querySelector('option[value=""]');
      if (blankOpt) blankOpt.remove();
      selectEl.value = this.vars.group_type || 'User';
    }
    typeHead.appendChild(typeDD);

    const createdByHead = headRow.insertCell(5);
    createdByHead.innerHTML = 'Created by';

    const createdHead = headRow.insertCell(6);
    createdHead.innerHTML = 'Created';

    const updatedHead = headRow.insertCell(7);
    updatedHead.innerHTML = 'Updated';

    const privateHead = headRow.insertCell(8);
    privateHead.innerHTML = 'Private';
  },

  getSelectedGroupType() {
    const typeEl = U.id('advisorGroupTypeDD');
    return normaliseGroupType(typeEl ? typeEl.value : this.vars.group_type);
  },

  captureListReturnState() {
    return {group_type: this.getSelectedGroupType()};
  },

  async onGroupTypeChange() {
    this.vars.group_type = this.getSelectedGroupType();
    const res = await O.PREP([await O.mPOST(EP, {group_type: this.vars.group_type})]);
    const listData = res[EP] || {};
    const rows = Array.isArray(listData.data) ? listData.data : [];
    await this.buildTableBody(rows);
  },

  async buildTableBody(listData) {
    const tbody = U.id('advisorGroupsTableBody');
    tbody.innerHTML = '';

    if (!listData.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = COL_COUNT;
      cell.innerHTML = 'No advisor groups found.';
      return;
    }

    for (const row of listData) {
      const tr = tbody.insertRow();

      const openDetail = tr.insertCell(0);
      const linkSVG = svg.linkNewPage();
      linkSVG.style.cursor = 'pointer';
      linkSVG.setAttribute('role', 'button');
      linkSVG.setAttribute('title', 'View advisor group');
      linkSVG.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        listReturnState.save('ViewAdvisorGroup', {
          listPage: 'AdvisorGroups',
          state: this.captureListReturnState(),
        });
        O.PREP('ViewAdvisorGroup', `h_advisor_group_id=${row.h_advisor_group_id}`);
      });
      openDetail.appendChild(linkSVG);

      const values = [
        cellText(row.group_name) || '—',
        cellText(row.group_description) || '—',
        row.user_count != null && String(row.user_count).trim() !== '' ? String(row.user_count) : '—',
        cellText(row.group_type) || '—',
        createdByName(row),
        await dateTimeText(row.created_date),
        await dateTimeText(row.updated_date),
        ynText(row.private_yn),
      ];
      values.forEach((value, i) => {
        const cell = tr.insertCell(i + 1);
        cell.textContent = value;
      });
    }
  },
};
